import React from 'react';
import barometre from '../../../img/logos-applications/satisfaction.png';
import bourseEmploi from '../../../img/logos-applications/bourse-d-emploi.png';
import congres from '../../../img/logos-applications/congres-des-notaires.png';
import adsn from '../../../img/logos-applications/adsn.png';
import extrant from '../../../img/logos-applications/extranet-conseil-regional-boradeaux.png';
import hectaur from '../../../img/logos-applications/hectaur.png';
import immobilier from '../../../img/logos-applications/immobilier-notaires.png';
import kiosque from '../../../img/logos-applications/kiosque-conseils-notaires.png';
import formacen from '../../../img/logos-applications/formacen.png';
import mastructure from '../../../img/logos-applications/ma-structure.png';
import management from '../../../img/logos-applications/management-en-pratique.png';
import notadirect from '../../../img/logos-applications/notadirect.png';
import territoires from '../../../img/logos-applications/notaires-et-territoires.png';
import odeon from '../../../img/logos-applications/odeon.png';
import oscar from '../../../img/logos-applications/oscar.png';
import preval from '../../../img/logos-applications/preval.png';
import formation from '../../../img/logos-applications/portail-inscription-formations.png';
import prisme from '../../../img/logos-applications/prisme-office.png';
import projetEntreprise from '../../../img/logos-applications/projet-d-entreprise.png';
import radar from '../../../img/logos-applications/radar.png';
import vigilance from '../../../img/logos-applications/vigilance.png';
import zeropapier from '../../../img/logos-applications/zero-papier.png';

function CarrouselLogos(): JSX.Element {
  const img = [
    {
      label: 'Satisfaction',
      src: barometre,
    },
    {
      label: 'Bourse d\'emploi',
      src: bourseEmploi,
    },
    {
      label: 'Congrès des notaires de France',
      src: congres,
    },
    {
      label: 'Espace en ligne ADSN',
      src: adsn,
    },
    {
      label: 'Extranet Conseil Régional Notaires CA de Bordeaux',
      src: extrant,
    },
    {
      label: 'Hectaur',
      src: hectaur,
    },
    {
      label: 'Immobilier notaires - Espace pro',
      src: immobilier,
    },
    {
      label: 'Kiosque Conseils des notaires',
      src: kiosque,
    },
    {
      label: 'Formacen',
      src: formacen,
    },
    {
      label: 'Ma structure',
      src: mastructure,
    },
    {
      label: 'Management en pratique',
      src: management,
    },
    {
      label: 'Notadirect',
      src: notadirect,
    },
    {
      label: 'Notaires et territoires',
      src: territoires,
    },
    {
      label: 'Odéon',
      src: odeon,
    },
    {
      label: 'Oscar',
      src: oscar,
    },
    {
      label: 'Preval',
      src: preval,
    },
    {
      label: 'Portail d\'insciption aux Formations en Ligne',
      src: formation,
    },
    {
      label: 'Prisme Office',
      src: prisme,
    },
    {
      label: 'Projet d\'entreprise',
      src: projetEntreprise,
    },
    {
      label: 'Radar',
      src: radar,
    },
    {
      label: 'Vigilance',
      src: vigilance,
    },
    {
      label: 'Zéro papier',
      src: zeropapier,
    },
  ];
  return (
    <div id="slider">
      <figure>
        {img.map((i) => (
          <div key={i.label}>
            <img src={i.src} alt={i.label} />
            <span>{i.label}</span>
          </div>
        ))}
      </figure>
    </div>
  );
}

export default CarrouselLogos;
